<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <div class="batch" style="margin: 20px 0">
          <el-button type="primary" @click="batchHandle">批量启用</el-button>
          <el-button type="danger" @click="batchDel">批量禁用</el-button>
          <span v-if="selectLen > 0" style="margin-left: 10px; color: gray">(已选：{{selectLen}})</span>
          <!-- <el-button @click="batchTranslate">翻译本页标题</el-button> -->
        </div>
        <zv-table :table="table" @on-selection-change="handleSelectionChange" ref="dataTable"></zv-table>
      </div>
    </div>
  </div>
</template>
<script>
import api from "./api";
import addFormMixin from "@/mixins/addFormMixin";
import formPageMixin from "@/mixins/formPageMixin";
import TipUtil from "@/utils/utils/TipUtil";
export default {
  name: "commentManagement",
  mixins: [addFormMixin, formPageMixin],
  components: {},
  data() {
    let vm = this;
    return {
      // 查询条件ori
      selectLen: '',
      batchIds: "",
      showMoreSearch: false,
      searchFormDataOri: {
        area_id_arr: [],
        area_id: "",
      },
      searchFormData: {},
      keywordsTypes: [
        {
          label: "标题",
          value: 1
        },
        {
          label: "内容",
          value: 2
        }
      ],
      table: {
        api: api.commentList,
        query: {
          
        },
        searchData: [
          {
            type: "input",
            model: "platform",
            placeholder: "发布平台"
          },
          {
            type: "select",
            model: "ispublish",
            placeholder: "是否发布",
            option: [
              {label: "是", value: 1},
              {label: "否", value: 0}
            ]
          }
        ],
        columns: [
          {
            type:"selection",
            width:"55"
          },
          {
            title: "评论内容",
            key: "content",
            minWidth: "250",
            showTooltip: true
          },
          {
            title: "点赞数",
            key: "like"
          },
          {
            title: "系统点赞数",
            key: "like_base",
            minWidth: "110",
            render(h, ctx) {
              return h("input", 
                {
                  attrs: {
                    value: ctx.row.like_base 
                  },
                  style: {
                    width: "100px"
                  },
                  on: {
                    input: vm.likeValFn,
                    blur: vm.likeFn.bind(this,ctx.row.id)
                  },
                }
              );
            }
          },
          {
            title: "发布时间",
            key: "add_time",
            minWidth: "110",
            showTooltip: true,
            sortable: true,
            render(h, ctx) {
              return h("span", vm.$commFunc.formatDate(ctx.row.add_time));
            }
          },
          {
            title: "发布人",
            key: "sign_name"
          },
          {
            title: "所属文章",
            key: "title"
          },
          {
            title: "发布平台",
            key: "platform"
          },
          {
            title: "操作",
            fixed: "right",
            minWidth: "100",
            render(h, ctx) {
              const editBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doOpen.bind(this, ctx.row)
                  }
                },
                ctx.row.ispublish == 0 ? "启用":"禁用"
              );

              const delBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doDelete.bind(this, ctx.row.id)
                  }
                },

                "删除"
              );
              const topBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doIstop.bind(this, ctx.row)
                  }
                },
                ctx.row.istop == 0 ? "置顶":"取消置顶"
                
              );

              let arr = [];
              arr.push(editBtn);
              if(ctx.row.ispublish == 1 ) {
                arr.push(topBtn);
              }
              return h("span", arr);
            }
          }
        ],
      },
      formDataOri: {
        app_name: ""
      },
      formRules: {
        app_name: [
          {
            required: true,
            message: "App名称不能为空",
            trigger: "blur"
          }
        ]
      },
      deleteApi: api.commentDelete,
      deleteSuccessMsg: "删除成功",
      likeVal: ''
    };
  },

  methods: {
    likeValFn(val) {
      this.likeVal = val.target.value
    },
    async likeFn(val) {
      let datas = {
        id: val,
        count: this.likeVal
      }
      let res = await api.likeSet(datas)
      TipUtil.message("系统点赞数修改成功", "success");
      this.$refs.dataTable.refresh()
    },
    async doOpen(row) {
      let datas
      let msgs
      if(row.ispublish == 0) {
        datas = {
          id: row.id,
          ispublish: 1
        }
        msgs = "启用成功"
      }else {
        datas = {
          id: row.id,
          ispublish: 0
        }
        msgs = "禁用成功"
      }
      let res = await api.ispublishSet(datas)
      TipUtil.message(msgs, "success");
      this.$refs.dataTable.refresh()
    },
    async doIstop(rows) {
      let datas
      if(rows.istop == 0 ) {
        datas = {
          id: rows.id,
          istop: 1
        }
      }else {
        datas = {
          id: rows.id,
          istop: 0
        }
      }
      let res = await api.istopSet(datas)
      TipUtil.message("操作成功", "success");
      this.$refs.dataTable.refresh()

    },
    async getCDQueryData() {
      let res = await api.getCDQueryData();
      console.log(res);
      let processObj = Object.assign(
        {},
        this.$_.cloneDeep(this.searchFormDataOri),
        res.query
      );

      this.processSavedQuery(processObj);
      this.searchFormData = processObj;
      this.searchClick();
    },

    processSavedQuery(processObj) {
      if (processObj.cat_id) {
        processObj.cat_id = parseInt(processObj.cat_id);
      }

      if (processObj.lan_id) {
        processObj.lan_id = parseInt(processObj.lan_id);
      }

      if (processObj.source_ids) {
        processObj.source_id = processObj.source_ids.join(",")
      }

      if (processObj.qtype) {
        processObj.qtype = parseInt(processObj.qtype);
      }

      processObj.area_id_arr = processObj.area_id
        ? processObj.area_id.split(",").map(item => parseInt(item))
        : [];

      if (processObj.publish_time_begin) {
        this.publish_time_begin_str = this.$commFunc.formatDate(
          processObj.publish_time_begin
        );
      }

      if (processObj.publish_time_end) {
        this.publish_time_end_str = this.$commFunc.formatDate(
          processObj.publish_time_end
        );
      }
      if (processObj.add_time_begin) {
        this.add_time_begin_str = this.$commFunc.formatDate(
          processObj.add_time_begin
        );
      }
      if (processObj.add_time_end) {
        this.add_time_end_str = this.$commFunc.formatDate(
          processObj.add_time_end
        );
      }
      processObj.tag_id_arr = processObj.tag_id
        ? processObj.tag_id.split(",").map(item => parseInt(item))
        : [];
    },

    processSubmitQuery() {
      let processObj = this.$_.cloneDeep(this.searchFormData);
      processObj.area_id = processObj.area_id_arr.join(",");
      processObj.publish_time_begin = this.$commFunc.parseToTimestamp(
        this.publish_time_begin_str
      );
      processObj.publish_time_end = this.$commFunc.parseToTimestamp(
        this.publish_time_end_str
      );
      processObj.add_time_begin = this.$commFunc.parseToTimestamp(
        this.add_time_begin_str
      );
      processObj.add_time_end = this.$commFunc.parseToTimestamp(
        this.add_time_end_str
      );
      processObj.tag_id = processObj.tag_id_arr.join(",");
      return processObj;
    },

    async getAreaList() {
      this.areaList = await this.$commFunc.getAreaList({
        area_type: 2
      });
    },
    async getLanguageList() {
      this.languageList = await this.$commFunc.getCollectLanguageList();
    },
    async getSourceList(val) {
      let datas
      if(val == "") {
        datas = {
          page: 1,
          pagesize: this.$enums.allPageSize,
        }
      }else {
        datas = {
          page: 1,
          pagesize: this.$enums.allPageSize,
          area_id: val
        }
      }
      let res = await api.collectSourceList(datas);
      this.sourceList = res.list;
    },
    async getCollectSourceTagList() {
      let res = await api.collectSourceTagList({});
      this.selectTagsList = res.list;
    },

    async addTagClick() {
      if (this.selectTagValue == "") {
        TipUtil.message("请选择标签", "error");
        return false;
      }

      let formTagArr = this.searchFormData.tag_id_arr;
      let findIndex = formTagArr.findIndex(item => item == this.selectTagValue);
      if (findIndex > -1) {
        TipUtil.message("标签已存在，请勿重复", "error");
        return false;
      } else {
        formTagArr.push(this.selectTagValue);
      }
      this.selectTagValue = "";
    },

    deleteTag(index) {
      this.searchFormData.tag_id_arr.splice(index, 1);
    },

    searchClick(val) {
      let processObj = this.processSubmitQuery();
      if(processObj.source_ids.length > 0) {
        this.$set(processObj,"source_id",processObj.source_ids.join(","))
      }
      console.log(processObj)
      if(val == "on") {
        this.$set(processObj, "page", true);
      }
      this.$set(this.table, "query", processObj);
      this.$refs.dataTable.refresh();
    },

    async saveQueryClick() {
      let processObj = this.processSubmitQuery();
      await api.saveCDQueryData(processObj);
      TipUtil.message("搜索条件保存成功", "success");
    },

    resetQueryClick() {
      this.searchFormData = this.$_.cloneDeep(this.searchFormDataOri);
      this.$refs.searchForm.resetFields();
      this.publish_time_begin_str = "";
      this.publish_time_end_str = "";
      this.add_time_begin_str = "";
      this.add_time_end_str = "";
    },

    toggleShowMore() {
      this.showMoreSearch = !this.showMoreSearch;
    },

    saveCDQueryData() {},

    customDeleteParams(id) {
      return {
        id,
        status: 2
      };
    },
    // 国家下来菜单筛选
    selectAreaFn(val) {
      this.getSourceList(val.join(","))
    },
    // 多选操作
    handleSelectionChange(val) {
      let arrs = []
      val.forEach(item => 
        arrs.push(item.id)
      )
      this.selectLen = val.length
      this.batchIds = arrs.join(",")
    },
    // 批量删除
    async batchDel() {
      let res = await api.ispublishSet({
        id: this.batchIds,
        ispublish: 0
      });
      if(res.error_code == 0) {
        TipUtil.message("批量禁用成功！", "success");
        this.$refs.dataTable.refresh();
      }
    },
    // 批量处理
    async batchHandle() {
      let res = await api.ispublishSet({
        id: this.batchIds,
        ispublish: 1
      });
      if(res.error_code == 0) {
        TipUtil.message("批量启用成功！", "success");
        this.$refs.dataTable.refresh();
      }
    },
    // 批量翻译
    batchTranslate() {

    },
    doViewDetail(id) {
      let routeData = this.$router.resolve("/data-input/collectDataDetail?id=" + id);
      window.open(routeData.href, '_blank');
    }
  },

  created() {
    // this.getCDQueryData();
    // this.getAreaList();
    // this.getLanguageList();
    // this.getSourceList();
    // this.getCollectSourceTagList();
  },

  mounted() {},
  beforeDestroy() {}
};
</script>

<style lang="less" scoped>
.cd-search-form-wrap {
  position: relative;
  overflow: hidden;
  &.style-hide-more {
    height: 40px;
  }
}

.show-more-toggle-wrapper {
  display: flex;
  justify-content: center;
  padding: 5px 0 15px;
}
.show-more-toggle-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #999;
  font-size: 12px;
  i {
    margin-right: 5px;
  }
}
.cd-search-form {
  .el-form-item {
    margin-bottom: 10px;
  }

  .cdd-status-sec2 {
    display: flex;
  }

  .cdd-status-sec22 {
    margin-right: 5px;
    .el-tag + .el-tag {
      margin-left: 5px;
    }
  }
}
</style>
